import React, { useEffect } from 'react'
 import Bid from "./home-page/Bid.js"
 import Top from './home-page/Top.js'
 import  BuyNow  from '../cards/Featured.js'
 import Makes from './home-page/Makes.js'
 import Abouttest from '../about/about-page/Abouttest.js'
 import BidNow from '../cards/BuyNow.js'
 import BidCarsSection from '../cards/BidCarsSection.js'
 import Aboutdest from '../about/about-page/Aboutdest.js'
 import LocalCars from '../cards/LocalCarsSection.js'
 import Partners from '../home/home-page/Partners.js'
 import LiveCars from './livecars-section/LiveAuction.js'
 import Registration from './home-page/Registration.js'

const Home = () => {
  
  useEffect(() => {
    localStorage.setItem("apiEndpoint", process.env.REACT_APP_API_CARS_LIVE);
  }, []);

  return (
    <>
    <Bid/>
    <Top/>
    <BidCarsSection />
    <Makes/>
    <BuyNow/>
    <BidNow/>
    <LocalCars />
    <LiveCars />
    <Aboutdest/>
    <Abouttest/>
    <Partners/>
    <Registration/>
    </>
  )
}

export default Home